import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate, useLocation, NavigateFunction, createSearchParams } from 'react-router-dom';
import { match } from 'path-to-regexp';


export type navigateDataProps = {
    key: string;
    name: string;
    pathName: string,
    onClick?: () => void;
    disabled_match?: boolean;
    searchParams?: Record<string, string> | any
}
type Props = {
    navigateData: navigateDataProps[];
}
const NavigateListCustom: React.FC<Props> = (props: Props) => {
    const { navigateData } = props;
    const navigate: NavigateFunction = useNavigate();
    const location = useLocation();
    const currentPath: string = location.pathname;

    const handleNavigate = (navigate: NavigateFunction, pathName: string, state?: any) => {
        navigate(pathName, { state: { ...state } })
    }
    const handleSearchParams = (navigate: NavigateFunction, pathName: string, search: Record<string, string> | any) => {
        navigate({
            pathname: pathName,
            search: createSearchParams({
                ...search
            }).toString()
        })
    }

    const navigateElements = () => {
        return navigateData.map((list) => {
            const isMatch = match(list.pathName, { decode: decodeURIComponent })(currentPath);
            return <Link
                underline="hover"
                sx={{
                    cursor: "pointer",
                }}
                key={list.key}

                color={isMatch ? 'black' : 'inherit'}
                onClick={() => {
                    if (list.searchParams) {
                        handleSearchParams(navigate, list.pathName, list.searchParams);
                        list.onClick && list.onClick();
                    } else {
                        list.onClick && list.onClick();
                        handleNavigate(navigate, list.pathName);
                    }
                }}>
                <Typography sx={{ color: isMatch && !list.disabled_match ? 'black' : 'rgba(0,0,0,0.5)' }}>
                    {list.name}
                </Typography>
            </Link>
        })
    }

    return (
        <Stack spacing={2}>
            <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
            >
                {navigateElements()}
            </Breadcrumbs>
        </Stack>
    );
}

export default NavigateListCustom